import { Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import { SubHeader } from '../../utils/componentes-utiles/SubHeader';
import { getOpcionesAdmin } from '../../services/apis';
import { OpcionesMenuNav } from '../../utils/componentes-utiles/OpcionesMenuNav';

export const Admin = () => {

    const [opciones, setOpciones] = useState([]);
    const [loaded, setLoaded] = useState([]);
    const navigate = useNavigate();
    const cargarOpciones = async () => {
        try {
            const response = await getOpcionesAdmin();
            if(response.data.length === 0){
                navigate('/');
            }
            setOpciones(response.data)
            setLoaded(true);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }
    };

    useEffect(() => {
        cargarOpciones();
    }, []);

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            xs={12}
        >

            <Grid
                container
                direction="column"
                justifyContent="start"
                alignItems="center"
                xs={12}
                gap={2}
                sx={{ minHeight: '65vh' }}
            >
                <SubHeader titulo={'Administrador'}></SubHeader>

                <OpcionesMenuNav opciones={opciones}></OpcionesMenuNav>
            </Grid>

        </Grid>
    )
}
